import { createUseStyles } from '../../theme/theming';

const useSectionStyles = createUseStyles((theme) => {
  return {
    bannerCarouselCenterSection: {
      width: '100%',
      textAlign: 'center',
      position: 'relative',

      '&, & *, & *:before, & *:after': {
        fontFamily: theme?.typography?.fontFamily,
        boxSizing: 'border-box'
      }
    },
    sectionContainer: {
      width: '100%',
      // maxWidth: ({ containerWidth } = {}) => containerWidth,
      position: 'absolute',
      zIndex: '9',
      height: '100%'
    },
    absoluteButtons: {
      display: 'flex',
      gap: '20px',
      justifyContent: 'center',
      bottom: '10%',
      position: 'absolute',
      width: '100%'
    },
    buttonClass: {
      margin: `${theme.spacing.margin.tiny}px 0px`
    },
    contentContainer: {
      display: 'flex',
      alignItems: 'center'
    },

    centerBgImageContainer: {
      width: '100%',
      position: 'relative',
      // paddingBottom: '35rem',
      paddingBottom: ({ isCustomWebsite }) =>
        isCustomWebsite ? '55%' : 'unset',
      backgroundSize: 'cover',
      backgroundPosition: 'center center'
    },

    centerBgImage: {
      objectFit: 'cover',
      width: '100%',
      backgroundSize: 'cover',
      backgroundPosition: 'center center'
    },

    partialBackground: {
      height: '100%'
    },
    textContainer: {
      padding: `${theme.spacing.padding.regular}px ${theme.spacing.padding.medium}px`,
      // margin: `0px ${theme.spacing.padding.medium} 0px ${theme.spacing.padding.medium}`,
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column'
    },
    subTitleHeading: {
      color: theme?.palette?.font?.invertedDefault,
      marginBottom: '8px',
      fontSize: theme.typography.fontSize.subHead,
      wordBreak: 'break-word',
      letterSpacing: '3px'
    },
    heading: {
      margin: '0',
      fontSize: theme.typography.fontSize.h1,
      color: theme?.palette?.font?.invertedDefault,
      wordBreak: ({ wordBreakValue }) => wordBreakValue || 'break-word',
      lineHeight: '80px'
    },
    description: {
      color: theme?.palette?.font?.invertedDefault,
      lineHeight: '32px',
      fontWeight: '400',
      wordBreak: 'break-word',
      fontSize: theme.typography.fontSize.description
    },

    sideBannerImage: {
      width: '100%',
      height: 'calc(100% - 100px)',
      objectFit: 'cover',
      objectPosition: '50% 50%'
    },

    overlay: {
      zIndex: 1,
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.4)'
    },

    contentContainerWithMobile: {},
    textContainerWithMobile: {},
    centerBgImageContainerWithMobile: {},
    headingWithMobile: {},
    subTitleHeadingWithMobile: {},
    descriptionWithMobile: {},

    '@media screen and (max-width: 767px)': {
      heading: {
        fontSize: theme.typography.fontSize.h2,
        lineHeight: '40px',
        color: '#333'
      },

      headingWithMobile: {
        color: '#fff'
      },

      subTitleHeading: {
        color: '#333'
      },

      subTitleHeadingWithMobile: {
        color: '#fff'
      },

      partialBackground: {
        display: 'none'
      },

      contentContainerWithMobile: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      },

      contentContainer: {
        display: 'flex',
        flexDirection: 'column-reverse'
      },

      textContainerWithMobile: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        padding: '24px 16px',
        height: '100%',
        width: '100%',
        zIndex: '99',
        background: 'trasparent'
      },

      textContainer: {
        padding: '24px 16px'
      },

      // textContainer: {
      //   position: ({ mobileImage }) => mobileImage ? 'absolute' : '',
      //   padding: ({ mobileImage }) => mobileImage ? '20px 20px' : '24px 16px',
      //   height: ({ mobileImage }) => mobileImage ? '100%' : '',
      //   width: ({ mobileImage }) => mobileImage ? '100%' : '',
      //   zIndex: ({ mobileImage }) => mobileImage ? '99' : '',
      //   background: ({ mobileImage }) => mobileImage ? 'transparent' : theme?.palette?.background?.primary
      // },

      description: {
        fontSize: '16px',
        lineHeight: '24px',
        color: '#333'
      },
      descriptionWithMobile: {
        width: '100%',
        wordBreak: 'break-all',
        color: '#fff'
      },
      centerBgImageContainer: {
        width: ({ isCustomWebsite }) => (isCustomWebsite ? '100%' : '100%'),
        position: 'relative',
        height: '15rem',
        minHeight: '200px',
        paddingBottom: '0'
      },

      centerBgImageContainerWithMobile: {
        // height: '40rem',
        width: '100%',
        aspectRatio: '1/2'
      },

      sectionContainer: {
        position: 'unset'
      },

      centerBgImage: {
        objectFit: 'cover',
        width: '100%',
        height: 'inherit'
      }
    }
  };
});

export default useSectionStyles;
